export const DATA_HOOK = {
    title: 'list-item-action-title',
    subtitle: 'list-item-action-subtitle',
    prefixIcon: 'list-item-action-prefix-icon',
    suffix: 'list-item-action-suffix',
    suffixIcon: 'list-item-action-suffix-icon',
    tooltip: 'list-item-action-tooltip',
};
export const SIZE = {
    small: 'small',
    medium: 'medium',
};
export const SKIN = {
    standard: 'standard',
    dark: 'dark',
    destructive: 'destructive',
    premium: 'premium',
    primary: 'primary',
};
//# sourceMappingURL=ListItemAction.constants.js.map